import React, { useEffect, useRef, useState } from "react";
import { Typography, Box, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import DataTable from "datatables.net-bs5";
import $ from "jquery";
import moment from "moment";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "./RaiseComplaint.css";
import { complaintAPI } from "../services/api";
import { escapeHtml, escapeHtmlAttr, renderStatusHtml } from "../utils/xss";
import { useSidebar } from "../contexts/SidebarContext";

const ApprovalSR = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const srTableRef = useRef(null);
  const dataTableInstanceRef = useRef(null);
  const dateRangePickerRef = useRef(null);
  const { sidebarOpen } = useSidebar();

  // Filter states
  const [statusFilter, setStatusFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateRangeText, setDateRangeText] = useState("");
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      setLoading(true);
      try {
        const items = [];

        if (!mounted) return;

        // Store all data
        setAllData(items);
        setFilteredData(items);

        // Ensure datatable plugin registered
        if (!$.fn.DataTable) {
          DataTable($);
        }

        // Destroy previous instance
        if (dataTableInstanceRef.current) {
          dataTableInstanceRef.current.destroy();
          dataTableInstanceRef.current = null;
        }

        dataTableInstanceRef.current = $(srTableRef.current).DataTable({
          data: items,
          paging: true,
          searching: true,
          info: true,
          lengthChange: true,
          lengthMenu: [5, 10, 25, 50, 100],
          pageLength: 5,
          dom: "lfrtip",
          ordering: true,
          destroy: true,
          scrollX: true,
          autoWidth: false,
          fixedColumns: false,
          columns: [
            {
              title: "SNo.",
              data: null,
              render: (d, type, row, meta) => (meta.row + 1).toString(),
              className: "text-center",
            },
            {
              title: "SR Number",
              data: null,
              render: (d) => {
                const id = d.id || d.complaintId || d.ComplaintId || d.Id;
                const num =
                  d.srNumber ||
                  d.SRNumber ||
                  d.complaintNumber ||
                  d.complaintNo ||
                  d.ComplaintNumber ||
                  d.ComplaintNo ||
                  id;
                return `<a href="#" class="sr-link" data-id="${escapeHtmlAttr(id)}">${escapeHtml(num)}</a>`;
              },
            },
            {
              title: "SR Category",
              data: null,
              render: (d) =>
                d.complaintTypeName ||
                d.ComplaintTypeName ||
                d.complaintCategory ||
                "",
            },
            {
              title: "Item Category",
              data: null,
              render: (d) =>
                d.productCategory || d.ProductCategory || d.productName || "",
            },
            {
              title: "Current Status",
              data: null,
              render: (d) => {
                const status =
                  d.statusName || d.StatusName || d.currentStatus || "";
                return renderStatusHtml(status);
              },
            },
            {
              title: "Raised By",
              data: null,
              render: (d) =>
                d.createdByName || d.CreatedByName || d.raisedBy || "",
            },
            {
              title: "Assigned To",
              data: null,
              render: (d) =>
                d.assignedToName || d.AssignedToName || d.assignedTo || "",
            },
          ],
          initComplete: function (settings, json) {
            try {
              // Wrap dt-length and dt-search into a single top filter wrapper
              const wrapper = $(srTableRef.current).closest(
                ".dataTables_wrapper, .dt-container"
              );
              if (wrapper.length > 0) {
                const lengthEl = wrapper.find(".dt-length");
                const searchEl = wrapper.find(".dt-search");
                if (lengthEl.length > 0 || searchEl.length > 0) {
                  let topWrap = wrapper.find(".dtFltrTop");
                  if (topWrap.length === 0) {
                    topWrap = $(
                      "<div class='dtFltrTop d-flex flex-wrap'></div>"
                    );
                    wrapper.prepend(topWrap);
                  }
                  lengthEl.each(function () {
                    $(this).appendTo(topWrap);
                  });
                  searchEl.each(function () {
                    $(this).appendTo(topWrap);
                  });
                }

                // Wrap dt-info and dt-paging into a single bottom filter wrapper
                const infoEl = wrapper.find(".dt-info");
                const pagingEl = wrapper.find(".dt-paging");
                if (infoEl.length > 0 || pagingEl.length > 0) {
                  let bottomWrap = wrapper.find(".dtFltrBotm");
                  if (bottomWrap.length === 0) {
                    bottomWrap = $(
                      "<div class='dtFltrBotm d-flex flex-wrap'></div>"
                    );
                    wrapper.append(bottomWrap);
                  }
                  infoEl.each(function () {
                    $(this).appendTo(bottomWrap);
                  });
                  pagingEl.each(function () {
                    $(this).appendTo(bottomWrap);
                  });
                }
              }

              // Wrap dt-scroll with an inner wrapper and ensure outer wrapper has dtScrlWrpr
              const dtScrollDiv = $(srTableRef.current).closest(".dt-scroll");
              if (dtScrollDiv.length > 0) {
                if (!dtScrollDiv.parent().hasClass("dtScrlWrprInner")) {
                  dtScrollDiv.wrap('<div class="dtScrlWrprInner"></div>');
                }
                const outer = dtScrollDiv.parent().parent();
                if (outer.length > 0) outer.addClass("dtScrlWrpr");
              } else {
                const container = $(srTableRef.current).closest(
                  ".table-responsive"
                );
                if (container.length > 0) {
                  const dtScroll = container.find(".dt-scroll");
                  if (dtScroll.length > 0) {
                    dtScroll.each(function () {
                      const $this = $(this);
                      if (!$this.parent().hasClass("dtScrlWrprInner")) {
                        $this.wrap('<div class="dtScrlWrprInner"></div>');
                      }
                      const outer = $this.parent().parent();
                      if (outer.length > 0) outer.addClass("dtScrlWrpr");
                    });
                  }
                }
              }
            } catch (error) {
              console.error("Error in initComplete:", error);
            }
          },
        });

        // click handler for SR link
        $(srTableRef.current).off("click", ".sr-link");
        $(srTableRef.current).on("click", ".sr-link", function (e) {
          e.preventDefault();
          const id = $(this).data("id");
          if (id) navigate(`/complaints/${id}`);
        });
      } catch (err) {
        console.error("Failed to load SRs", err);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    load();

    return () => {
      mounted = false;
      if (dataTableInstanceRef.current) {
        dataTableInstanceRef.current.destroy();
        dataTableInstanceRef.current = null;
      }
      if (srTableRef.current) {
        $(srTableRef.current).off("click", ".sr-link");
      }
    };
  }, [navigate]);

  // Filter handlers
  const handleFilter = () => {
    let filtered = [...allData];

    // Filter by status
    if (statusFilter) {
      filtered = filtered.filter((item) => {
        const status =
          item.statusName || item.StatusName || item.currentStatus || "";
        return status.toLowerCase() === statusFilter.toLowerCase();
      });
    }

    // Filter by date range
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      filtered = filtered.filter((item) => {
        const itemDate = new Date(item.createdDate || item.CreatedDate);
        return itemDate >= start && itemDate <= end;
      });
    } else if (startDate) {
      const start = new Date(startDate);
      filtered = filtered.filter((item) => {
        const itemDate = new Date(item.createdDate || item.CreatedDate);
        return itemDate >= start;
      });
    } else if (endDate) {
      const end = new Date(endDate);
      filtered = filtered.filter((item) => {
        const itemDate = new Date(item.createdDate || item.CreatedDate);
        return itemDate <= end;
      });
    }

    setFilteredData(filtered);

    // Update DataTable
    if (dataTableInstanceRef.current) {
      dataTableInstanceRef.current.clear();
      dataTableInstanceRef.current.rows.add(filtered);
      dataTableInstanceRef.current.draw();
    }
  };

  const handleReset = () => {
    setStatusFilter("");
    setStartDate("");
    setEndDate("");
    setDateRangeText("");
    setFilteredData(allData);

    // Clear daterangepicker
    if (dateRangePickerRef.current) {
      $(dateRangePickerRef.current).val("");
    }

    // Update DataTable
    if (dataTableInstanceRef.current) {
      dataTableInstanceRef.current.clear();
      dataTableInstanceRef.current.rows.add(allData);
      dataTableInstanceRef.current.draw();
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  // Initialize daterangepicker
  useEffect(() => {
    if (dateRangePickerRef.current) {
      const $input = $(dateRangePickerRef.current);

      $input.daterangepicker({
        autoUpdateInput: false,
        locale: {
          cancelLabel: "Clear",
          applyLabel: "Apply",
          format: "DD-MM-YYYY",
        },
        opens: "left",
        drops: "down",
      });

      $input.on("apply.daterangepicker", function (ev, picker) {
        const start = picker.startDate.format("YYYY-MM-DD");
        const end = picker.endDate.format("YYYY-MM-DD");
        const displayText =
          picker.startDate.format("DD-MM-YYYY") +
          " - " +
          picker.endDate.format("DD-MM-YYYY");

        setStartDate(start);
        setEndDate(end);
        setDateRangeText(displayText);
        $(this).val(displayText);
      });

      $input.on("cancel.daterangepicker", function (ev, picker) {
        setStartDate("");
        setEndDate("");
        setDateRangeText("");
        $(this).val("");
      });

      // Cleanup
      return () => {
        if ($input.data("daterangepicker")) {
          $input.off("apply.daterangepicker");
          $input.off("cancel.daterangepicker");
          $input.data("daterangepicker").remove();
        }
      };
    }
  }, []);

  // Handle sidebar toggle - recalculate DataTable columns
  useEffect(() => {
    if (dataTableInstanceRef.current) {
      // Wait for CSS transition to complete (300ms as defined in App.js)
      const timer = setTimeout(() => {
        try {
          dataTableInstanceRef.current.columns.adjust().draw(false);
        } catch (error) {
          console.error("Error adjusting DataTable columns:", error);
        }
      }, 350); // 350ms to ensure transition completes

      return () => clearTimeout(timer);
    }
  }, [sidebarOpen]);

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Typography
          variant="h4"
          component="h1"
          className="service-request-heading"
          sx={{ color: "#333333", fontWeight: 600 }}
        >
          Approval SR List
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate("/raise-complaint")}
          sx={{
            backgroundColor: "#1976d2",
            "&:hover": {
              backgroundColor: "#1565c0",
            },
          }}
        >
          Raise SR
        </Button>
      </Box>

      {/* Filter Panel */}
      <div className="card-panel mb-3 filter-panel">
        <div className="section-heading d-flex align-items-center gap-2 mb-3">
          <FilterListIcon fontSize="small" className="text-muted" />
          <span>Filter Service Requests</span>
        </div>

        <div className="container-fluid">
          <div className="row g-3">
            {/* Status Dropdown */}
            <div className="col-12 col-md-6 col-lg-3">
              <label className="input-label">Status</label>
              <select
                className="form-select form-control-light filter-select"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">All Status</option>
                <option value="Open">Open</option>
                <option value="Reopen">Reopen</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
                <option value="Closed">Closed</option>
              </select>
            </div>

            {/* Date Range Picker */}
            <div className="col-12 col-md-6 col-lg-6">
              <label className="input-label">Date Range</label>
              <div
                className="input-icon filter-daterange-wrapper filter-daterangepickerWrpr"
                style={{ position: "relative" }}
              >
                <input
                  type="text"
                  ref={dateRangePickerRef}
                  className="form-control form-control-light filter-daterangepicker"
                  placeholder="Select date range"
                  readOnly
                />
                <CalendarTodayIcon
                  className="icon-right"
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    width: "16px",
                    height: "16px",
                    color: "#6c757d",
                  }}
                />
              </div>
            </div>

            {/* Action Buttons */}
            <div className="col-12 col-md-6 col-lg-3">
              <label
                className="input-label d-block"
                style={{ visibility: "hidden" }}
              >
                Actions
              </label>
              <div className="d-flex gap-2 filter-buttons">
                <button
                  type="button"
                  className="btn btn-filter flex-fill"
                  onClick={handleFilter}
                  style={{
                    background:
                      "linear-gradient(135deg, #7a00f5  0%, #0f00f5 100%)",
                    border: "none",
                    color: "white",
                    fontWeight: 600,
                    boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                    borderRadius: "4px",
                    padding: "8px 24px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background =
                      "linear-gradient(135deg, #0f00f5 0%, #0f00f5 100%)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow =
                      "0 6px 20px rgba(102, 126, 234, 0.6)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background =
                      "linear-gradient(135deg, #7a00f5  0%, #0f00f5 100%)";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 15px rgba(102, 126, 234, 0.4)";
                  }}
                  onMouseDown={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                  onMouseUp={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                >
                  <FilterListIcon fontSize="small" className="me-1" />
                  Filter
                </button>
                <button
                  type="button"
                  className="btn btn-reset-filter"
                  onClick={handleReset}
                  title="Reset"
                  style={{
                    background:
                      "linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)",
                    border: "none",
                    color: "white",
                    fontWeight: 600,
                    boxShadow: "0 4px 15px rgba(132, 250, 176, 0.4)",
                    borderRadius: "4px",
                    padding: "8px 16px",
                    transition: "all 0.3s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow =
                      "0 6px 20px rgba(132, 250, 176, 0.6)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 15px rgba(132, 250, 176, 0.4)";
                  }}
                  onMouseDown={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                  onMouseUp={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                >
                  <RestartAltIcon fontSize="small" />
                </button>
                <button
                  type="button"
                  className="btn btn-back-filter"
                  onClick={handleBack}
                  title="Back"
                >
                  <ArrowBackIcon fontSize="small" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Paper
        sx={{
          p: 0,
          backgroundColor: "transparent",
          boxShadow: "none",
          border: "none",
        }}
      >
        <div className="card-panel mt-0">
          {/* <div className="section-heading">SR List</div> */}
          <div className="table-responsive">
            <table
              ref={srTableRef}
              className="table table-striped table-bordered complaint-table custmTblLst"
              style={{ width: "100%" }}
            ></table>
          </div>
        </div>
      </Paper>
    </Box>
  );
};

export default ApprovalSR;





